import { jsxs as B, jsx as n } from "react/jsx-runtime";
import { c as C } from "./clsx.OuTLNxxd.js";
import { NeuButton as s } from "@hcahealthcaredpx/neutron-react";
import { Link as a } from "@sitecore-jss/sitecore-jss-nextjs";
const $ = ({
  primaryStyles: e,
  primaryText: o,
  primaryKind: r = "primary",
  primaryType: c = "button",
  isPrimaryDisabled: d = !1,
  onPrimaryClick: m,
  buttonsAlignment: f = "start",
  secondaryStyles: p,
  secondaryText: i,
  secondaryKind: u = "tertiary",
  secondaryType: k = "button",
  isSecondaryDisabled: b = !1,
  onSecondaryClick: h,
  wrapperClassName: N,
  secondaryIcon: j,
  primaryIcon: v,
  primaryButtonLinkFields: t,
  secondaryButtonLinkFields: l
}) => {
  const y = t ? {
    as: a,
    field: t,
    role: "link",
    type: void 0
  } : {}, A = l ? {
    as: a,
    field: l,
    role: "link",
    type: void 0
  } : {};
  return /* @__PURE__ */ B(
    "div",
    {
      className: C(`d-flex column-gap-1 justify-content-${f}`, N),
      children: [
        i && /* @__PURE__ */ n(
          s,
          {
            kind: u,
            type: k,
            disabled: b,
            onClick: h,
            "aria-label": i,
            className: p,
            icon: j,
            ...A,
            children: i
          }
        ),
        o && /* @__PURE__ */ n(
          s,
          {
            kind: r,
            type: c,
            disabled: d,
            onClick: m,
            "aria-label": o,
            className: e,
            icon: v,
            ...y,
            children: o
          }
        )
      ]
    }
  );
};
export {
  $ as M
};
